import Avito, { AvitoSchema } from './Avito'
import Adgram, { AdgramSchema } from './Adgram'
import Adsmarket, { AdsmarketSchema } from './Adsmarket'
import Appnext, { AppnextSchema } from './Appnext'
import BigoAds, { BigoAdsSchema } from './BigoAds'
import DirectAdvert, { DirectAdvertSchema } from './DirectAdvert'
import Facebook, { FacebookSchema } from './Facebook'
import FacebookHighRisk, { FacebookHighRiskSchema } from './FacebookHighRisk'
import GoogleAds, { GoogleAdsSchema } from './GoogleAds'
import Mobidriven, { MobidrivenSchema } from './Mobidriven'
import MytargetInt, { MytargetIntSchema } from './Mytargetint'
import Otm, { OtmSchema } from './Otm'
import Pornhub, { PornhubSchema } from './Pornhub'
import Snapchat, { SnapchatSchema } from './Snapchat'
import Taboola, { TaboolaSchema } from './Taboola'
import TargetMail, { TargetMailSchema } from './TargetMail'
import TelegramAds, { TelegramAdsSchema } from './TelegramAds'
import Tiktok, { TiktokSchema } from './Tiktok'
import Vk, { VkSchema } from './Vk'
import VkAds, { VkAdsSchema } from './VkAds'
import Yahoo, { YahooSchema } from './Yahoo'
import Yandex, { YandexSchema } from './Yandex'
import YandexBusiness, { YandexBusinessSchema } from './YandexBusiness'
import YandexZen, { YandexZenSchema } from './YandexZen'
import Zeropark, { ZeroparkSchema } from './Zeropark'
import YandexGeo, { YandexGeoSchema } from './YandexGeo'
import OzonPerformance, { OzonPerformanceSchema } from './OzonPerformance'
import PetalAds, { PetalAdsSchema } from './PetalAds'
import MiAds, { MiAdsSchema } from './MiAds'
import AppleSearchAds, { AppleSearchAdsSchema } from './AppleSearchAds'
import UnityAds, { UnityAdsSchema } from 'modules/Forms/Account/Create/UnityAds'
import MicrosoftAds, { MicrosoftAdsSchema } from './MicrosoftAds'
import WowBlogger, { WowBloggerSchema } from './WowBlogger'
import VkAdBlogger, { VkAdBloggerSchema } from 'modules/Forms/Account/Create/VkAdBlogger'
import GoogleAdsHighRisk, {
  GoogleAdsHighRiskSchema,
} from 'modules/Forms/Account/Create/GoogleAdsHighRisk'
import TwoGis, { TwoGisSchema } from 'modules/Forms/Account/Create/TwoGis'
import AdGod, { AdGodSchema } from 'modules/Forms/Account/Create/AdGod'
import SberAds, { SberAdsSchema } from 'modules/Forms/Account/Create/SberAds'
import AvitoAds, { AvitoAdsSchema } from 'modules/Forms/Account/Create/AvitoAds'

export default {
  avito: { component: Avito, schema: AvitoSchema, formName: 'CreateAvitoAccountForm' },
  facebook: { component: Facebook, schema: FacebookSchema, formName: 'CreateFacebookAccountForm' },
  'facebook-high-risk': {
    component: FacebookHighRisk,
    schema: FacebookHighRiskSchema,
    formName: 'CreateFacebookHighRiskAccountForm',
  },
  yd: { component: Yandex, schema: YandexSchema, formName: 'CreateYdAccountForm' },
  'yandex-business': {
    component: YandexBusiness,
    schema: YandexBusinessSchema,
    formName: 'CreateYandexBusinessAccountForm',
  },
  vk: { component: Vk, schema: VkSchema, formName: 'CreateVkAccountForm' },
  adsmarket: {
    component: Adsmarket,
    schema: AdsmarketSchema,
    formName: 'CreateAdsMarketAccountForm',
  },
  targetmail: {
    component: TargetMail,
    schema: TargetMailSchema,
    formName: 'CreateTargetMailAccountForm',
  },
  'vk-ads': { component: VkAds, schema: VkAdsSchema, formName: 'CreateVkAdsAccountForm' },
  'yandex-zen': {
    component: YandexZen,
    schema: YandexZenSchema,
    formName: 'CreateYandexZenAccountForm',
  },
  directadvert: {
    component: DirectAdvert,
    schema: DirectAdvertSchema,
    formName: 'CreateDirectAdvertAccountForm',
  },
  zeropark: { component: Zeropark, schema: ZeroparkSchema, formName: 'CreateZeroparkAccountForm' },
  yahoo: { component: Yahoo, schema: YahooSchema, formName: 'CreateYahooAccountForm' },
  adgram: { component: Adgram, schema: AdgramSchema, formName: 'CreateAdgramAccountForm' },
  otm: { component: Otm, schema: OtmSchema, formName: 'CreateOtmAccountForm' },
  snapchat: { component: Snapchat, schema: SnapchatSchema, formName: 'CreateSnapchatAccountForm' },
  pornhub: { component: Pornhub, schema: PornhubSchema, formName: 'CreatePornhubAccountForm' },
  trafficjunky: { component: Pornhub, schema: PornhubSchema, formName: 'CreatePornhubAccountForm' },
  mytargetint: {
    component: MytargetInt,
    schema: MytargetIntSchema,
    formName: 'CreateMyTargetIntAccountForm',
  },
  tiktok: { component: Tiktok, schema: TiktokSchema, formName: 'CreateTiktokAccountForm' },
  taboola: { component: Taboola, schema: TaboolaSchema, formName: 'CreateTaboolaAccountForm' },
  'telegram-ads': {
    component: TelegramAds,
    schema: TelegramAdsSchema,
    formName: 'CreateTelegramAdsAccountForm',
  },
  'google-ads': {
    component: GoogleAds,
    schema: GoogleAdsSchema,
    formName: 'CreateGoogleAdsAccountForm',
  },
  'google-high-risk': {
    component: GoogleAdsHighRisk,
    schema: GoogleAdsHighRiskSchema,
    formName: 'CreateGoogleAdsHighRiskAccountForm',
  },
  'bigo-ads': { component: BigoAds, schema: BigoAdsSchema, formName: 'CreateBigoAdsAccountForm' },
  mobidriven: {
    component: Mobidriven,
    schema: MobidrivenSchema,
    formName: 'CreateMobidrivenAccountForm',
  },
  appnext: { component: Appnext, schema: AppnextSchema, formName: 'CreateAppnextAccountForm' },
  'yandex-geoadv': {
    component: YandexGeo,
    schema: YandexGeoSchema,
    formName: 'CreateYandexGeoAccountForm',
  },
  'ozon-performance': {
    component: OzonPerformance,
    schema: OzonPerformanceSchema,
    formName: 'CreateOzonPerformanceAccountForm',
  },
  'petal-ads': {
    component: PetalAds,
    schema: PetalAdsSchema,
    formName: 'CreatePetalAdsAccountForm',
  },
  'mi-ads': { component: MiAds, schema: MiAdsSchema, formName: 'CreateMiAdsAccountForm' },
  'apple-search-ads': {
    component: AppleSearchAds,
    schema: AppleSearchAdsSchema,
    formName: 'CreateAppleSearchAdsAccountForm',
  },
  'unity-ads': {
    component: UnityAds,
    schema: UnityAdsSchema,
    formName: 'CreateUnityAdsAccountForm',
  },
  'microsoft-advertising': {
    component: MicrosoftAds,
    schema: MicrosoftAdsSchema,
    formName: 'CreateMicrosoftAdsAccountForm',
  },
  wowblogger: {
    component: WowBlogger,
    schema: WowBloggerSchema,
    formName: 'CreateWowBloggerAccountForm',
  },
  'vk-adblogger': {
    component: VkAdBlogger,
    schema: VkAdBloggerSchema,
    formName: 'CreateVkAdBloggerAccountForm',
  },
  'two-gis': {
    component: TwoGis,
    schema: TwoGisSchema,
    formName: 'CreateTwoGisAccountForm',
  },
  'ad-god': {
    component: AdGod,
    schema: AdGodSchema,
    formName: 'CreateAdGodAccountForm',
  },
  'sber-ads': {
    component: SberAds,
    schema: SberAdsSchema,
    formName: 'CreateSberAdsAccountForm',
  },
  'avito-ads': {
    component: AvitoAds,
    schema: AvitoAdsSchema,
    formName: 'CreateAvitoAdsAccountForm',
  },
}
